import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { EnvironmentService } from 'src/app/services/environment.service';
import { EventsContent, EventsPageConfig, FacilityConfig } from 'src/environments/environment.interface';
import { mergeEventsContent, setCanonicalHref } from '../steelhaus-page.util';

/**
 * Steelhaus "Events & Celebrations" page. Gated and fully content-driven via
 * `config.eventsPage` (Steelhaus only).
 */
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit {
  settings: FacilityConfig;
  pageConfig?: EventsPageConfig;
  showPage = false;
  content: Required<EventsContent>;

  constructor(private env: EnvironmentService, private title: Title, private meta: Meta) {
    this.settings = this.env.getFacilityConfig();
    this.pageConfig = this.settings.eventsPage;
    this.content = mergeEventsContent(this.pageConfig?.content);
  }

  ngOnInit(): void {
    this.showPage = !!this.pageConfig?.show;
    if (!this.showPage) {
      return;
    }
    const pageTitle = `${this.pageConfig?.metaTitle ?? 'Events & Celebrations'} — ${this.settings.name}`;
    const desc =
      this.pageConfig?.metaDescription ??
      'Host your next celebration at Steelhaus — birthdays, anniversaries, and team building in your own private room.';
    this.title.setTitle(pageTitle);
    this.setSocialMeta(pageTitle, desc);
  }

  private setSocialMeta(pageTitle: string, description: string): void {
    const meta = (this.settings.meta as any) || {};
    const url = typeof window !== 'undefined' ? window.location.href : '';
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: meta.ogImage || '' });
    this.meta.updateTag({ property: 'og:url', content: url });
    setCanonicalHref(url);
  }
}
